import React, {
  Fragment,
  useReducer,
  useEffect,
  useState,
  forwardRef
} from "react";

import DatePicker from "../../components/Datepicker/";
import jsPDF from "jspdf";
import "jspdf-autotable";
import MaterialSelect from "../../components/MaterialSelect";
import api from "../../services/api";
import MaterialTable from "material-table";
import { TextField, Button } from "@material-ui/core";
import { TableChart, Search, PictureAsPdf } from "@material-ui/icons";
import PictureAsPdfTwoToneIcon from '@material-ui/icons/PictureAsPdfTwoTone';
import { makeStyles } from '@material-ui/core/styles';

import moment from "moment";
import * as XLSX from 'xlsx';

const initialState = {
  SelectedEmployeeName: null,
  SelectedEmployeeStatus: null,
  SelectedEmployeeFunction: null,
  SelectedEmployeeSector: null,
  SelectedEmployeeCompany: null,
  onlyExpiredDocument: false
};

function reducer(filter, { field, value }) {
  return {
    ...filter,
    [field]: value
  };
}

const useStyles = makeStyles({
  pdf: {
    marginLeft:"10px",
  },
});

const EmployeeReport = () => {
  const classes = useStyles();
  const [filter, dispatch] = useReducer(reducer, initialState);
  const [dataEmployee, setDataEmployee] = useState({
    load: true,
    employeeFunctions: [],
    employeeStatuses: [],
    employeeData: [],
    initialDate: null,
    finalDate: null,
    columns: [
      { title: "ID", field: "id" },
      { title: "Nome", field: "name" },
      { title: "CPF", field: "cpf" },
      { title: "Empresa", field: "company" },
      { title: "CNPJ", field: "cnpj" },
      { title: "Status", field: "status" },
      { title: "Função", field: "function" },
      { title: "Data de Cadastro", field: "createdAt" },
      { title: "Setor", field: "sector" }
    ]
  });

  const onChange = e => {
    const { name, value } = e.target;
    dispatch({ field: name, value: value });
  };

  useEffect(() => {
    fetchAPI();
  }, []);

  const fetchAPI = async () => {
    setDataEmployee({ ...dataEmployee, load: true });
    const status = await api.get(`/employee-status`);
    const functions = await api.get(`/functions?order_by=description`);
    const sectors = await api.get(`/sectors?status=1`);
    const employees = await api.get(
      `/employees/?order_by=id&order_direction=DESC`
    );

    const data = employees.data ? await formatEmployees(employees) : null;

    setDataEmployee({
      ...dataEmployee,
      employeeStatuses: status.data.rows,
      employeeFunctions: functions.data.rows,
      employeesSectors: sectors.data.rows,
      employeeData: data,
      load: false
    });
  };

  const formatEmployees = async employees => {
    return await employees.data.rows.map(item => {
      return {
        id: item.id,
        name: item.name,
        cpf: item.cpf,
        company: item.Company ? item.Company.socialName : "Não definido",
        cnpj: item.Company ? item.Company.cnpj : "Não definido",
        status: item.EmployeeStatus
          ? item.EmployeeStatus.description
          : "Não definido",
        function: item.Function ? item.Function.description : "Não definido",
        createdAt: moment.utc(item.createdAt).format("DD/MM/YYYY"),
        sector: item.Sector ? item.Sector.name : "Não definido"
      };
    });
  };

  const setDate = (value, key) => {
    setDataEmployee({ ...dataEmployee, [key]: value });
  };

  const searchEmployee = async () => {
    setDataEmployee({ ...dataEmployee, load: true });
    const {
      SelectedEmployeeName,
      SelectedEmployeeStatus,
      SelectedEmployeeFunction,
      SelectedEmployeeSector,
      SelectedEmployeeCompany
    } = filter;
    const { initialDate, finalDate } = dataEmployee;

    const startDate = initialDate ? `&startDate=${initialDate}` : "";

    const fDate = finalDate ? `&finalDate=${finalDate}` : "";
    const statusId = SelectedEmployeeStatus
      ? `&EmployeeStatusId=${SelectedEmployeeStatus}`
      : "";
    const name = SelectedEmployeeName ? `&name=${SelectedEmployeeName}` : "";

    const sector = SelectedEmployeeSector
      ? `&SectorId=${SelectedEmployeeSector}`
      : "";
    const func = SelectedEmployeeFunction
      ? `&FunctionId=${SelectedEmployeeFunction}`
      : "";

    const company = SelectedEmployeeCompany
      ? `&EmployeeCompanyName=${SelectedEmployeeCompany}`
      : "";
    const response = await api.get(
      `/employees?order_by=id&order_direction=DESC${statusId}${name}${func}${sector}${startDate}${fDate}${company}`
    );

    const formatedEmployees = await formatEmployees(response);

    setDataEmployee({
      ...dataEmployee,
      employeeData: formatedEmployees,
      load: false
    });
  };

  const customPdfButton = () => {
    const title = "DPWCDI Report - Colaboradores";
    const fileName = `DPWCDI Report Colaboradores - ${moment().format(
      "DD/MM/YYYY"
    )}`;

    // Build date range subtitle if dates are provided
    let dateRangeText = "";
    if (dataEmployee.initialDate || dataEmployee.finalDate) {
      const startDate = dataEmployee.initialDate ? moment(dataEmployee.initialDate).format("DD/MM/YYYY") : "...";
      const endDate = dataEmployee.finalDate ? moment(dataEmployee.finalDate).format("DD/MM/YYYY") : "...";
      dateRangeText = `Período: ${startDate} - ${endDate}`;
    }

    const headers = [
      [
        "ID",
        "Nome",
        "CPF",
        "Empresa",
        "CNPJ",
        "Status",
        "Função",
        "Criado",
        "Setor"
      ]
    ];

    const data = dataEmployee.employeeData.map(item => [
      item.id,
      item.name,
      item.cpf,
      item.company,
      item.cnpj,
      item.status,
      item.function,
      item.createdAt,
      item.sector
    ]);

    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);
    let currentY = 20;

    // Add title
    doc.text(title, marginLeft, currentY);
    currentY += 20;

    // Add date range if provided
    if (dateRangeText) {
      doc.setFontSize(12);
      doc.text(dateRangeText, marginLeft, currentY);
      currentY += 15;
    }

    let content = {
      startY: currentY + 10,
      head: headers,
      body: data
    };

    doc.autoTable(content);
    doc.save(fileName);
  };

  const exportToExcel = () => {
    // Create workbook
    const wb = XLSX.utils.book_new();
    
    // Prepare headers and data
    const headers = ['ID', 'Nome', 'CPF', 'Empresa', 'CNPJ', 'Status', 'Função', 'Data de Cadastro', 'Setor'];
    const data = dataEmployee.employeeData.map(item => [
      item.id,
      item.name,
      item.cpf,
      item.company,
      item.cnpj,
      item.status,
      item.function,
      item.createdAt,
      item.sector
    ]);

    // Build date range text if dates are provided
    let dateRangeText = "";
    if (dataEmployee.initialDate || dataEmployee.finalDate) {
      const startDate = dataEmployee.initialDate ? moment(dataEmployee.initialDate).format("DD/MM/YYYY") : "...";
      const endDate = dataEmployee.finalDate ? moment(dataEmployee.finalDate).format("DD/MM/YYYY") : "...";
      dateRangeText = `Período: ${startDate} - ${endDate}`;
    }

    // Create worksheet structure with title and optional date range
    let worksheetData = [
      [], // Empty row
      ['DPWCDI Report - Colaboradores'], // Title
      [`Gerado em: ${moment().format('DD/MM/YYYY HH:mm')}`] // Generation date
    ];

    // Add date range if provided
    if (dateRangeText) {
      worksheetData.push([dateRangeText]);
    }

    // Add empty row and headers
    worksheetData.push([], headers, ...data);

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // Calculate merges based on whether date range is included
    const titleRowIndex = 1;
    const dateGenRowIndex = 2;
    const dateRangeRowIndex = dateRangeText ? 3 : -1;
    const headerRowIndex = dateRangeText ? 5 : 4;

    // Merge cells for title, generation date, and optional date range
    ws['!merges'] = [
      { s: { r: titleRowIndex, c: 0 }, e: { r: titleRowIndex, c: 8 } }, // Title spans columns A-I
      { s: { r: dateGenRowIndex, c: 0 }, e: { r: dateGenRowIndex, c: 8 } } // Generation date spans columns A-I
    ];

    // Add date range merge if it exists
    if (dateRangeText) {
      ws['!merges'].push({ s: { r: dateRangeRowIndex, c: 0 }, e: { r: dateRangeRowIndex, c: 8 } });
    }

    // Set column widths
    ws['!cols'] = [
      { wch: 8 },   // ID
      { wch: 25 },  // Nome
      { wch: 15 },  // CPF
      { wch: 30 },  // Empresa
      { wch: 18 },  // CNPJ
      { wch: 15 },  // Status
      { wch: 20 },  // Função
      { wch: 15 },  // Data de Cadastro
      { wch: 20 }   // Setor
    ];

    // Style header row with blue background and white text
    headers.forEach((header, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: headerRowIndex, c: index });
      if (ws[cellRef]) {
        ws[cellRef].s = {
          font: { bold: true, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '1e88e5' } },
          alignment: { horizontal: 'center', vertical: 'center' }
        };
      }
    });

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Colaboradores');

    // Generate filename with current date
    const fileName = `DPWCDI_Report_Colaboradores_${moment().format('DD-MM-YYYY')}.xlsx`;

    // Save file
    XLSX.writeFile(wb, fileName);
  };

  const {
    SelectedEmployeeName,
    SelectedEmployeeStatus,
    SelectedEmployeeFunction,
    SelectedEmployeeSector,
    SelectedEmployeeCompany
  } = filter;

  const tableIcons = {
    Export: forwardRef((props, ref) => (
      <Button
        size="small"
        className={"btn-info"}
        startIcon={<TableChart {...props} ref={ref} color="action" />}
        onClick={exportToExcel}
      >
        XLS
      </Button>
    ))
  };

  return (
    <Fragment>
      <div className="col-md-12">
        <h3 class="card-title mt-1">Filtros de Empresas</h3>
        <hr />
        <div className="row mb-2 p-20">
          <div className="col-md-2">
            <TextField
              name="SelectedEmployeeCompany"
              label="Empresa"
              value={SelectedEmployeeCompany}
              onChange={onChange}
            />
          </div>
        </div>
        <hr />
        <h3 class="card-title mt-4">Filtros de Colaboradores</h3>
        <hr />
        <div className="row mb-2 p-20">
          <div className="col-md-2 m-auto">
            <DatePicker
              name="initialDate"
              data={dataEmployee.initialDate}
              onChange={e => setDate(e, "initialDate")}
              dateLabel="Data inicio"
            />
          </div>
          <div className="col-md-2 m-auto">
            <DatePicker
              name="finalDate"
              data={dataEmployee.finalDate}
              onChange={e => setDate(e, "finalDate")}
              dateLabel="Data final"
            />
          </div>
          <div className="col-md-2 m-auto">
            <TextField
              name="SelectedEmployeeName"
              label="Nome"
              value={SelectedEmployeeName}
              onChange={onChange}
            />
          </div>
        {/* </div> */}

        <hr />
        {/* <div className="row mb-2 p-20"> */}
          <div className="col-md-2">
            <MaterialSelect
              name="SelectedEmployeeStatus"
              dateLabel="Status"
              value={SelectedEmployeeStatus}
              data={dataEmployee.employeeStatuses}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <MaterialSelect
              name="SelectedEmployeeFunction"
              dateLabel="Função"
              value={SelectedEmployeeFunction}
              data={dataEmployee.employeeFunctions}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <MaterialSelect
              name="SelectedEmployeeSector"
              dateLabel="Setor"
              value={SelectedEmployeeSector}
              data={dataEmployee.employeesSectors}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="row mb-2 p-20">
          <div className="col-md-9"></div>
          <div className="col-md-3">
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={"btn-info"}
              startIcon={<Search />}
              onClick={searchEmployee}
            >
              Pesquisar
            </Button>
            <Button
              size="small"
              className={"btn-info"}
              startIcon={<PictureAsPdfTwoToneIcon />}
              onClick={customPdfButton}
              className={classes.pdf}
            >
              PDF
            </Button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mt-1">
            <MaterialTable
              title=""
              options={{
                exportButton: true,
                exportAllData: true,
                exportCsv: (columns, renderData) => {
                  // Override default CSV export to use our Excel function
                  exportToExcel();
                }
              }}
              icons={tableIcons}
              isLoading={dataEmployee.load}
              localization={{
                pagination: {
                  labelDisplayedRows: "{from}-{to} de {count}",
                  labelRowsSelect: "linhas",
                  previousTooltip: "Anterior",
                  nextTooltip: "Próxima",
                  lastTooltip: "Última"
                },
                body: {
                  emptyDataSourceMessage: "Não há dados a serem exibidos"
                },
                toolbar: {
                  searchPlaceholder: "Pesquisar",
                  exportTitle: "Exportar para Excel",
                  exportName: "Exportar para Excel"
                }
              }}
              columns={dataEmployee.columns}
              data={dataEmployee.employeeData}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EmployeeReport;